import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { EcommerceUserInfo } from 'src/app/models/models';
import { Ecommerce_User, User,Role } from 'src/app/models/RestModels';
import { RestResponse } from 'src/app/services/Rest';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'app-list-ecommerce-user',
	templateUrl: './list-ecommerce-user.component.html',
	styleUrls: ['./list-ecommerce-user.component.css'],
})

export class ListEcommerceUserComponent extends BaseComponent implements OnInit
{

	ecommerce_user_info_list: EcommerceUserInfo[] = [];
	ecommerce = GetEmpty.ecommerce();
	
	show_add_user: boolean = false;
	new_user: User = GetEmpty.user();
	roles: Role[] = [];
	new_ecommerce_user_info: Partial<EcommerceUserInfo> = {};

	ngOnInit(): void
	{
		this.path = '/list-ecommerce-user';

		this.sink = this.route.queryParamMap.pipe
		(
			mergeMap((x)=>
			{
				this.is_loading = true;

				let user = GetEmpty.user();
				user.type = 'CLIENT';

				let search = this.getSearch(x,['ecommerce_id'],[]);

				return forkJoin
				({
					ecommerce: this.rest.ecommerce.get( x.get('eq.ecommerce_id') ),
					ecommerce_user: this.rest.ecommerce_user_info.search( search ),
					roles: this.rest.role.search({limit: 1000})
				})
			})
		)
		.subscribe
		({
			error:(error)=>this.showError(error),
			next:(response)=>
			{
				this.ecommerce = response.ecommerce;
				this.ecommerce_user_info_list= response.ecommerce_user.data;
				this.roles = response.roles.data;
				this.is_loading = false;
			}
		});
	}

	addUser(event: Event)
	{
		event.preventDefault();
		this.is_loading = true;
	
		let ecommerce_user:Ecommerce_User = {
			id:0,
			user_id: 0,
			ecommerce_id: this.ecommerce.id,
			created: new Date(),
			updated: new Date(),
			created_by_user_id: this.rest.current_user.id,
			updated_by_user_id: this.rest.current_user.id,
			type: this.new_ecommerce_user_info.type
		};

		let ecommerce_user_info:EcommerceUserInfo = {
			ecommerce_user,
			user: this.new_user,
			type: this.new_ecommerce_user_info.type
		};

		this.is_loading = true;

		this.sink = this.rest.ecommerce_user_info.create(ecommerce_user_info )
		.subscribe
		({
			error:(error)=>this.showError(error),
			next:(_ecommerce_user_info)=>{
				this.is_loading = false;
				this.showSuccess('El usuario se ha registrado exitosamente');
				this.show_add_user = false;
				this.new_user = GetEmpty.user();
				//this.ecommerce_user_info_list.push(response.data);
				this.is_loading = false;
			}
		});
	}
}
